import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectPurchaseOfferShiftLevels = function () {
    return utilBalancing.getBalancing().PurchaseOfferShiftLevels;
};
export var selectPurchaseOfferShiftLevel = memoize(function (id) {
    return selectPurchaseOfferShiftLevels().get(id);
});
export var balancingPurchaseOfferShiftLevelsMemoizedFunctions = [
    selectPurchaseOfferShiftLevels,
    selectPurchaseOfferShiftLevel,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingPurchaseOfferShiftLevels.ts
// module id = 678
// module chunks = 3